import { render, staticRenderFns } from "./ClinicalCaseCarousel.vue?vue&type=template&id=5165d8b9"
import script from "./ClinicalCaseCarousel.vue?vue&type=script&lang=js"
export * from "./ClinicalCaseCarousel.vue?vue&type=script&lang=js"
import style0 from "./ClinicalCaseCarousel.vue?vue&type=style&index=0&id=5165d8b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports